import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../../Core/Image';

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  text-align: center;

  h2,
  h3 {
    margin: 1rem;
    color: ${({ headingColor }) =>
      headingColor ? themeGet(`colors.${headingColor}`) : 'inherit'};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 70%;
  }
`;

export const Heading = styled.h2`
  margin-bottom: 1rem;
  text-align: center;
  line-height: initial;

  span {
    font: inherit;
  }

  span.red {
    color: ${({ theme }) => theme.colors['pc-red']};
  }
`;

export const Subheading = styled.p`
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 1.5rem;
    line-height: 2.375rem;
    margin-bottom: 3rem;
  }
`;

export const StyledImage = styled(Image)`
  width: auto;
  margin: 0 auto;
  max-height: 20rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-height: 30rem;
    width: 50%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 40rem;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: ${({ flexDirectionColumn }) =>
      flexDirectionColumn ? 'column' : 'row'};
  }
`;

export const CTAWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  margin: 2rem auto 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  &.stacked {
    flex-direction: column;

    &.left {
      justify-content: flex-start;
      align-items: flex-start;
    }

    a {
      margin-bottom: 1rem;
    }
  }

  &.side-by-side,
  &.side-by-side.content-focus {
    @media only screen and (min-width: 500px) {
      justify-content: flex-start;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      flex-direction: column;
      align-items: flex-start;
    }

    a {
      margin-bottom: 1.5rem;
    }
  }

  a {
    margin: 0 auto;
    margin-bottom: 1.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Disclaimer = styled.div`
  margin: 2rem auto;
  a {
    color: currentColor;
    span {
      color: currentColor;
      font-size: inherit;
      font-weight: inherit;
    }
  }
`;
